import { decodeHTML } from 'entities';

const entityPattern = /&([a-z0-9#]+);/i;

/**
 * @name decodeHtmlEntities
 * @public
 * @description Converts HTML entities in a text string to their corresponding characters.
 * Only processes the text if it contains HTML entities.
 * @param {string} text - The text that may contain HTML entities
 * @returns {string} Text with HTML entities decoded to characters,
 * or original text if no entities found
 */
// eslint-disable-next-line import/prefer-default-export
export function decodeHtmlEntities(text) {
  if (!text) return '';

  const isHtmlEntity = text?.match(entityPattern);
  if (!isHtmlEntity) return text;

  return decodeHTML(text);
}
